import classNames from '@utils/classnames';
import React from 'react';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  /**
   * `plain` (default) — sits inside an existing container (table, card).
   * `panel` — standalone sunken box with a border, for empty pages / sections.
   */
  variant?: 'plain' | 'panel';
}

function renderIcon(icon: React.ReactNode) {
  if (React.isValidElement<{ className?: string }>(icon)) {
    return React.cloneElement(icon, { className: classNames('h-6 w-6', icon.props.className) });
  }
  return icon;
}

/** Say what is missing and offer the next step. */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
  variant = 'plain',
}) => {
  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center text-center',
        variant === 'panel' ? 'rounded-lg border border-border bg-surface-sunken px-5 py-8' : 'py-8',
        className,
      )}
    >
      {icon && <div className="mb-2 flex justify-center text-fg-muted">{renderIcon(icon)}</div>}
      <div className="text-sm font-semibold text-fg">{title}</div>
      {description && <div className="mt-1 max-w-md text-xs text-fg-muted">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};
